import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { SheetsDisplayGridRowDataFragmentGql } from './SheetsDisplayGridRowFragmentGql';

export const DatabaseDownstreamSheetsQueryGql: DocumentNode = gql`
query DatabaseDownstreamSheetsQuery($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  databases(filter: { id: $databaseId }) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowDataFragment
      }
    }
  }
}
${SheetsDisplayGridRowDataFragmentGql}
`;
